import ReactDOM from 'react-dom'
import { App } from './components'
import { actions } from 'actions'

actions.initialLoad().finally(() => {
    ReactDOM.render(<App />, document.getElementById('root'))
})
